
const ToolItem = ({ tool }) => {
  return (
    <li className='bg-yellow' id='tool-item'>{tool}</li>
  )
}

export default ToolItem
